import "./Painel.css";
import React, { useState } from "react";
import { Link, useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../AuthContext";

import {
  FaClipboardList,
  FaBars,
  FaCashRegister,
  FaShoppingCart,
  FaSignOutAlt,
  FaChartLine,
  FaCalendarAlt,
  FaCalendarCheck,
  FaUserFriends,
  FaUser,
  FaFileInvoiceDollar,
  FaBuilding,
  FaDownload,
  FaList,
  FaUserMd,
  FaHome,
} from "react-icons/fa";

import "primeicons/primeicons.css";

function Painel() {
  const { user, logout } = useAuth();
  const [showFloatingMenu, setShowFloatingMenu] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [atalhos, setAtalhos] = useState([]);
  
  // Estado para controlar quais seções estão expandidas
  const [expandedSections, setExpandedSections] = useState({
    Agenda: true, // Começa expandido
    Financeiro: true,
    Relatórios: true,
    Configurações: true,
    Sistema: true
  });

  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const toggleFloatingMenu = () => {
    setShowFloatingMenu(!showFloatingMenu);
    setShowOverlay(!showOverlay);
  };

  const closeMenu = () => {
    setShowFloatingMenu(false);
    setShowOverlay(false);
  };

  // Função para expandir/recolher seção
  const toggleSection = (sectionName) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionName]: !prev[sectionName]
    }));
  };

  const isActive = (path) => {
    const currentPath = location.pathname.replace("/app", "");
    return (
      currentPath === `/painel${path}` ||
      currentPath.startsWith(`/painel${path}`)
    );
  };

  const hasPermissao = (modulo, acao = "visualizar") => {
    if (!user) return false;

    // Administrador sempre tem acesso total
    if (user.tipo === "administrator") return true;

    // Usuário padrão -> verificar módulos
    if (user.tipo === "padrao" && user.modulos && user.modulos[modulo]) {
      return user.modulos[modulo][acao] === true;
    }

    return false;
  };

  const adicionarAtalho = (submenu) => {
    setAtalhos((prev) => {
      // Remove duplicados
      const filtrados = prev.filter((a) => a.path !== submenu.path);

      // Adiciona no final
      const novaFila = [...filtrados, submenu];

      // Garante máximo 5 (além da Home)
      return novaFila.slice(-5);
    });
  };

  const menuItems = [
    {
      name: "Agenda",
      submenus: [
        hasPermissao("Reservas") && {
          path: "/painel/reserva",
          name: "Reserva",
          icon: <FaCalendarAlt />,
        },
        hasPermissao("Agenda") && {
          path: "/painel/agenda",
          name: "Agenda",
          icon: <FaCalendarCheck />,
        },
      ].filter(Boolean),
    },
    {
      name: "Financeiro",
      submenus: [
        hasPermissao("Financeiro") && {
          path: "/painel/caixa",
          name: "Caixa",
          icon: <FaCashRegister />,
        },
        hasPermissao("Financeiro") && {
          path: "/painel/financeiro",
          name: "Despesa",
          icon: <FaFileInvoiceDollar />,
        },
      ].filter(Boolean),
    },
    {
      name: "Relatórios",
      submenus: [
        hasPermissao("Relatórios") && {
          path: "/painel/relatorios",
          name: "Relatórios",
          icon: <FaChartLine />,
        },
      ].filter(Boolean),
    },
    {
      name: "Configurações",
      submenus: [
        hasPermissao("Empresas") && {
          path: "/painel/Empresas",
          name: "Empresas",
          icon: <FaBuilding />,
        },
        hasPermissao("Pacientes") && {
          path: "/painel/pacientes",
          name: "Pacientes",
          icon: <FaUserFriends />,
        },
        hasPermissao("Profissionais") && {
          path: "/painel/Profissionais",
          name: "Profissionais",
          icon: <FaUserMd />,
        },
        hasPermissao("Usuarios") && {
          path: "/painel/Usuarios",
          name: "Usuários",
          icon: <FaUser />,
        },
        hasPermissao("Servicos") && {
          path: "/painel/Servicos",
          name: "Serviços",
          icon: <FaList />,
        },
        hasPermissao("Pedidos") && {
          path: "/painel/Pedidos",
          name: "Pedidos",
          icon: <FaClipboardList />,
        },
        hasPermissao("Arquivo") && {
          path: "/painel/Arquivo",
          name: "Arquivo",
          icon: <FaDownload />,
        },
      ].filter(Boolean),
    },
  ];

  return (
    <div className="painel-container">
      {/* Topbar */}
      <div className="sidebar">
        <button className="toggle-btn" onClick={toggleFloatingMenu}>
          {<FaBars />}
        </button>

        {/* Conteúdo da topbar */}
        <nav className="sidebar-menu">
          <ul>
            {/* Ícone HOME - SEMPRE FIXO NO INÍCIO */}
            <li>
              <Link
                to="/painel/dashboard"
                title="Dashboard"
                className={`submenu-icon-link ${isActive("/dashboard") ? "active" : ""}`}
              >
                <FaHome />
              </Link>
            </li>

            {/* Atalhos dinâmicos */}
            {atalhos.length > 0 &&
              atalhos.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    title={item.name}
                    className={`submenu-icon-link ${isActive(item.path.replace("/painel", "")) ? "active" : ""}`}
                  >
                    {item.icon}
                  </Link>
                </li>
              ))}
          </ul>
        </nav>

        {/* Floating Menu */}
        {showOverlay && (
          <div
            className={`floating-menu-overlay ${showOverlay ? "visible" : ""}`}
            onClick={closeMenu}
          />
        )}

        {showFloatingMenu && (
          <div className={`floating-menu ${showFloatingMenu ? "open" : ""}`}>
            {/* CABEÇALHO DO USUÁRIO COM ÍCONE HOME EM CÍRCULO */}
            <div className="floating-menu-user">
              <Link
                to="/painel/dashboard"
                onClick={closeMenu}
                title="Dashboard"
                style={{ textDecoration: "none" }}
              >
                <div className="floating-menu-home-circle">
                  <FaHome className="floating-menu-home-icon" />
                </div>
              </Link>
            </div>

            {menuItems.map((menu) => (
              <div key={menu.name} className="floating-menu-section">
                <div 
                  className="floating-menu-title" 
                  onClick={() => toggleSection(menu.name)}
                  style={{ cursor: 'pointer' }}
                >
                  <span>{menu.name}</span>
                  <span className={`pi pi-angle-down menu-arrow ${expandedSections[menu.name] ? 'expanded' : ''}`}></span>
                </div>
                {expandedSections[menu.name] && (
                  <ul>
                    {menu.submenus.map((submenu) => (
                      <li key={submenu.path}>
                        <Link
                          to={submenu.path}
                          onClick={() => {
                            adicionarAtalho(submenu);
                            closeMenu();
                          }}
                        >
                          <span className="floating-menu-icon">
                            {submenu.icon}
                          </span>
                          <span className="floating-menu-label">
                            {submenu.name}
                          </span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}

            <div className="floating-menu-section">
              <div 
                className="floating-menu-title" 
                onClick={() => toggleSection('Sistema')}
                style={{ cursor: 'pointer' }}
              >
                <span>Sistema</span>
                <span className={`pi pi-angle-down menu-arrow ${expandedSections.Sistema ? 'expanded' : ''}`}></span>
              </div>
              {expandedSections.Sistema && (
                <ul>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        closeMenu();
                        logout();
                      }}
                      className="logout-menu-item"
                    >
                      <span className="floating-menu-icon">
                        <FaSignOutAlt />
                      </span>
                      <span className="floating-menu-label">Sair</span>
                    </a>
                  </li>
                </ul>
              )}
            </div>
          </div>
        )}

        <div className="sidebar-footer">
          <button className="logout-btn" onClick={logout}>
            <FaSignOutAlt />
          </button>
        </div>
      </div>

      {/* Conteúdo principal */}
      <div className="main-content">
        <Outlet />
      </div>
    </div>
  );
}

export default Painel;